import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath, Rect } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    width={props.size || 36}
    height={props.size || 36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={18} cy={18} r={18} fill={props.bgColor || "#E7F4ED"}/>
    <G clipPath="url(#clip0_9022_8905)">
      <G filter="url(#filter0_d_9022_8905)">
        <Path
          d="M16.75 19.6667H16.1417L20.3917 24.0917C20.9 24.625 20.525 25.5 19.7917 25.5C19.5667 25.5 19.35 25.4083 19.1917 25.2417L14.1667 20.0083C13.95 19.7917 13.8333 19.4917 13.8333 19.1917C13.8333 18.5333 14.3667 18 15.025 18H16.75C18.2167 18 19.4333 16.9167 19.6333 15.5H13.8333C13.375 15.5 13 15.125 13 14.6667C13 14.2083 13.375 13.8333 13.8333 13.8333H19.3833C18.9167 12.85 17.9167 12.1667 16.75 12.1667H13.8333C13.375 12.1667 13 11.7917 13 11.3333C13 10.875 13.375 10.5 13.8333 10.5H22.1667C22.625 10.5 23 10.875 23 11.3333C23 11.7917 22.625 12.1667 22.1667 12.1667H20.2833C20.6833 12.65 20.9833 13.2167 21.1583 13.8333H22.1667C22.625 13.8333 23 14.2083 23 14.6667C23 15.125 22.625 15.5 22.1667 15.5H21.3167C21.1 17.8333 19.1333 19.6667 16.75 19.6667Z"
          fill={props.color || "#109648"}
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_9022_8905">
        <Rect width={20} height={20} fill="white" transform="translate(8 8)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
